import { render, staticRenderFns } from "./FormTemplateInput.vue?vue&type=template&id=60729632"
import script from "./FormTemplateInput.vue?vue&type=script&lang=js"
export * from "./FormTemplateInput.vue?vue&type=script&lang=js"
import style0 from "./FormTemplateInput.vue?vue&type=style&index=0&id=60729632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports